// extracted by mini-css-extract-plugin
module.exports = {"how":"HowItWorks_how__2dIjd","howButtons":"HowItWorks_howButtons__1ZMKJ"};